/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Overwrite_TextInputs */

const en_explorer_display_overwrite_text = /** @type {(inputs: Explorer_Display_Overwrite_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to overwrite this project?`)
};

const fr_explorer_display_overwrite_text = /** @type {(inputs: Explorer_Display_Overwrite_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etes-vous sur de vouloir ecraser ce projet ?`)
};

const de_explorer_display_overwrite_text = /** @type {(inputs: Explorer_Display_Overwrite_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie dieses Projekt wirklich überschreiben?`)
};

const it_explorer_display_overwrite_text = /** @type {(inputs: Explorer_Display_Overwrite_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler sovrascrivere questo progetto?`)
};

const ru_explorer_display_overwrite_text = /** @type {(inputs: Explorer_Display_Overwrite_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите перезаписать этот проект?`)
};

const es_explorer_display_overwrite_text = /** @type {(inputs: Explorer_Display_Overwrite_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que deseas sobrescribir este proyecto?`)
};

const zh_cn2_explorer_display_overwrite_text = /** @type {(inputs: Explorer_Display_Overwrite_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您确定要覆盖此项目吗？`)
};

const ja_explorer_display_overwrite_text = /** @type {(inputs: Explorer_Display_Overwrite_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプロジェクトを上書きしてもよろしいですか?`)
};

const hi_explorer_display_overwrite_text = /** @type {(inputs: Explorer_Display_Overwrite_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई इस प्रोजेक्ट को ओवरराइट करना चाहते हैं?`)
};

const pt_pt2_explorer_display_overwrite_text = /** @type {(inputs: Explorer_Display_Overwrite_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja sobrescrever este projeto?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to overwrite this project?" |
*
* @param {Explorer_Display_Overwrite_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_overwrite_text = /** @type {((inputs?: Explorer_Display_Overwrite_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Overwrite_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_overwrite_text(inputs)
	if (locale === "de") return de_explorer_display_overwrite_text(inputs)
	if (locale === "it") return it_explorer_display_overwrite_text(inputs)
	if (locale === "ru") return ru_explorer_display_overwrite_text(inputs)
	if (locale === "es") return es_explorer_display_overwrite_text(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_overwrite_text(inputs)
	if (locale === "ja") return ja_explorer_display_overwrite_text(inputs)
	if (locale === "hi") return hi_explorer_display_overwrite_text(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_overwrite_text(inputs)
	return en_explorer_display_overwrite_text(inputs)
});